import { useTranslations } from 'next-intl';
import { CustomImage as Image } from 'components/shared';
import { BentoHeading, BentoPara } from './StyleConstants';
import styles from './HRVCard.module.css';

export const HRVCard = ({ className }: { className?: string }) => {
  const t = useTranslations('ring');
  const tHome = useTranslations('home');
  return (
    <div className={`${styles.root} container${className ? ` ${className}` : ''}`}>
      <BentoHeading>{t('ring.bentoSection.hrvCard.head')}</BentoHeading>
      <BentoPara>{t('ring.bentoSection.hrvCard.desc')}</BentoPara>
      <div className="img-container">
        <Image
          alt={tHome('home.bentoCards.hrv.alt')}
          src="web_v2/illustrations/HRV-graph.png"
          fill
        />
      </div>
    </div>
  );
};
